import { Box, Button, Flex, Grid, GridItem, Input, Text } from "@chakra-ui/react";
import { Modal } from "antd";
import React from "react";
import UsersCsv from "../../../Assets/buyers_upload_template.csv";
import BulkUploadConfirmModal from "../../../Components/Modals/BulkUploadConfirmModal";

// Claude: extracted from Buyer.tsx 23-03-2026
interface Props {
  isOpen: boolean;
  onClose: () => void;
  bulkDocument: any;
  setBulkDocument: (doc: any) => void;
  fileInputKey: number;
  onShowConfirm: () => void;
  isConfirmOpen: boolean;
  onConfirmClose: () => void;
  onConfirmSubmit: () => void;
  bulkUploadDone: boolean;
}

const BuyerBulkUploadModal = ({
  isOpen, onClose, bulkDocument, setBulkDocument, fileInputKey, onShowConfirm,
  isConfirmOpen, onConfirmClose, onConfirmSubmit, bulkUploadDone,
}: Props) => (
  <>
    <Modal closeIcon={null} footer={null} title={null} open={isConfirmOpen} onOk={onConfirmClose} onCancel={onConfirmClose}>
      <BulkUploadConfirmModal
        role="buyer"
        eventName=""
        fileName={bulkDocument?.name}
        handleCloseModal={onConfirmClose}
        handleSubmit={onConfirmSubmit}
        uploadDone={bulkUploadDone}
      />
    </Modal>

    <Modal footer={null} title="Bulk Add Buyer" width="40%" open={isOpen} onCancel={onClose} onOk={onClose}>
      <Box p={2}>
        <Flex gap={2} alignItems="center">
          <Text>Download Sample CSV File</Text>
          <a href={UsersCsv} download={true}>
            <Button display="flex" justifyContent="center" alignItems="center" h="100%"
              background="#0E122F" color="white" px={3} gap={2} py={2} _hover={{ background: "#2E7D32" }}
            >
              Download
            </Button>
          </a>
        </Flex>
        <Text fontSize="xs" color="gray.500" mt={2} mb={1}>
          Event name column is optional — leave blank if not applicable.
        </Text>
        {/* Claude: existing-user merge behaviour note 08-03-2026 */}
        <Text fontSize="xs" color="blue.600" mt={1} mb={1}>
          <b>For existing accounts:</b> empty fields will be filled from the upload; fields that already have a value will not be overwritten. Use individual edits to change existing values.
        </Text>
        <Grid mt={3} gap={3} templateColumns="repeat(1, 1fr)">
          <GridItem colSpan={1}>
            <Box display="flex" flexDirection="column" gap="4px">
              <Text fontSize="xs" fontWeight="500">CSV File</Text>
              <Input
                type="file"
                height="28px" fontSize="xs"
                placeholder="Select File"
                name="buyerPersonName"
                key={fileInputKey}
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) setBulkDocument(e.target.files[0]);
                }}
              />
            </Box>
          </GridItem>
        </Grid>
        <Box mt={10}>
          {bulkDocument ? (
            <Flex justifyContent="end">
              <Button display="flex" justifyContent="center" alignItems="center" h="40px"
                background="#0E122F" color="white" px={3} gap={2} _hover={{ background: "#2E7D32" }}
                onClick={onShowConfirm}
              >
                Submit
              </Button>
            </Flex>
          ) : null}
        </Box>
      </Box>
    </Modal>
  </>
);

export default BuyerBulkUploadModal;
